import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export const Manifesto = () => {
  const { t } = useLanguage();
  const m = t.home.manifesto;
  return (
    <section className="relative bg-ink py-28 md:py-36 px-6 md:px-12 lg:px-20 border-t border-white/10">
      <p className="font-mono text-brand-cyan text-xs tracking-[0.25em] mb-4" data-testid="manifesto-eyebrow">
        {m.eyebrow}
      </p>
      <h2 className="font-syne text-4xl md:text-5xl tracking-tight text-white mb-16 max-w-2xl" data-testid="manifesto-title">
        {m.title}
      </h2>
      <div className="border-t border-white/10">
        {m.items.map((item, i) => (
          <motion.div
            key={item.num}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="grid grid-cols-1 md:grid-cols-[auto_1fr_2fr] gap-4 md:gap-10 items-start md:items-center py-8 md:py-10 border-b border-white/10"
            data-testid={`manifesto-item-${item.num}`}
          >
            <span className="font-syne text-4xl md:text-5xl text-white/15">{item.num}</span>
            <h3 className="font-syne text-xl md:text-2xl text-white">{item.title}</h3>
            <p className="font-manrope text-sm md:text-base text-white/55 leading-relaxed">{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
